import CircleIcon from "@mui/icons-material/Circle";
import { Box, Tooltip, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Base } from "ui/Scripts/source/framework/base";

export interface IAvatarNameProp {
    classes?: string;
    code?: string;
    date?: number;
    name: string;
    picture: string;
    suffixElement?: ReactNode;
}

export class AvatarName extends React.Component<IAvatarNameProp, {}> {
    render() {
        const props = this.props;
        return (
            <Box display="flex" alignItems="center" sx={{ cursor: "default", overflow: "hidden" }}>
                <Tooltip title={`${props.name}` + (props.date ? ` - ${Base.timeToDateTimeStr(props.date)}` : "")}>
                    <Box alignItems="center" sx={{ cursor: "default", display: "flex", flex: "1 1 0", minWidth: 0 }}>
                        <AvatarImage
                            id={props.code ?? props.name}
                            name={props.name}
                            image={props.picture}
                        />
                        <Typography sx={{ marginLeft: ".5rem", overflow: "hidden", textWrap: "nowrap" }} textOverflow="ellipsis">
                            {(props.name ?? "")}
                        </Typography>
                        {props.date && (
                            <CircleIcon sx={{ margin: "0 .5rem", fontSize: "12px", color: "action.selected" }} />
                        )}
                        <Typography sx={{ overflow: "hidden", textWrap: "nowrap" }} textOverflow="ellipsis">
                            {(props.date ? Base.timeToDateStr(props.date) : "")}
                        </Typography>
                    </Box>
                </Tooltip>
                {!!props.suffixElement &&
                    <Box sx={{ marginLeft: "auto" }}>
                        <Box sx={{ marginLeft: ".5rem", marginTop: "-4px", marginBottom: "-4px" }}>
                            {props.suffixElement}
                        </Box>
                    </Box>
                }
            </Box>
        );
    }
}